class FortunePriority {
    id!:          number;
    priorityId!:  number;
    description!: string;
}

export default FortunePriority;